import { showToast } from "../../utils/hot-toast";

const WithdrawAndSubmit = ({ presaleData, presaleContract, account }) => {
    const claimBackContribtuion = async () => {
        try {
            await presaleContract.methods
                .claimBackContribtuion()
                .send({ from: account });
            showToast(
                "SUCCESS",
                "You successfully withdrew your contribution!"
            );
        } catch (error) {
            console.log(error);
            if (error.code === 4001) {
                showToast("ERROR", error.message);
                return;
            }
            showToast("ERROR", "Something went wrong!");
        }
    };
    const publicCancel = async () => {
        await presaleContract.methods.cancelPresale().send({ from: account });
    };
    return (
        <div className="flex flex-col gap-4 mt-6">
            <div className="flex flex-row w-full justify-between items-center">
                <div className="flex flex-col items-start">
                    <span className="size-1">Emergency withdraw</span>
                    <span className="text-kadGrSt size-sm w-48">
                        Warning! 15% early withdraw fee will be taken.
                    </span>
                </div>
                <button
                    disabled={
                        presaleData.presaleState !== 1 ||
                        presaleData.presaleStartTime >=
                            new Date().getTime() / 1000
                    }
                    className="secGr-button w-32"
                    onClick={claimBackContribtuion}
                >
                    Withdraw
                </button>
            </div>
            <div className="hidden flex-row w-full justify-between items-center">
                <div className="flex flex-col items-start">
                    <span className="size-1">Public Cancel</span>
                    <span className="text-kadGrSt size-sm w-72">
                        Once activated owner has 48 hours to finalize or presale
                        will be cancelled
                    </span>
                </div>
                <button
                    className="blueGradient-button w-32"
                    onClick={publicCancel}
                    disabled={presaleData.presaleState !== 1}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};
export default WithdrawAndSubmit;
